<!--<div class="left-nav">-->
  <!--<div class="tab-card" (click)="tabClick('dashboard')" [ngClass]="{'active' : activeTab === ('/'+participantId+'/dashboard')}">-->
    <!--<div class="sae-icon sae-icon-home"></div>-->
    <!--<div class="tab-label">Dashboard</div>-->
  <!--</div>-->
  <!--<div class="tab-card" (click)="tabClick('students')" [ngClass]="{'active' : activeTab === ('/'+participantId+'/students')}">-->
    <!--<div class="sae-icon sae-icon-contacts"></div>-->
    <!--<div class="tab-label">Students</div>-->
  <!--</div>-->
  <!--<div class="tab-card" (click)="tabClick('account')" [ngClass]="{'active' : activeTab === ('/'+participantId+'/account')}">-->
    <!--<div class="sae-icon sae-icon-settings"></div>-->
    <!--<div class="tab-label">Account Settings</div>-->
  <!--</div>-->
<!--</div>-->
<div class="left-nav">
  <div class="tab-card" (click)="tabClick('dashboard')" [ngClass]="{'active' : activeTab === ('/dashboard')}">
    <div class="sae-icon sae-icon-home"></div>
    <div class="tab-label">Dashboard</div>
  </div>
  <div class="tab-card" (click)="tabClick('students')" [ngClass]="{'active' : activeTab === ('/students')}">
    <div class="sae-icon sae-icon-contacts"></div>
    <div class="tab-label">Students</div>
  </div>
  <div class="tab-card" (click)="tabClick('account')" [ngClass]="{'active' : activeTab === ('/account')}">
    <div class="sae-icon sae-icon-settings"></div>
    <div class="tab-label">Account Settings</div>
  </div>
</div>
